$(document).ready(function () {


    var url = window.location.pathname;
    var address = window.location.href;


    if(url == '/') {
        $( ".menu__ul > .menu__li" ).eq(0).addClass('active');
    }else{
        $('.menu__li > .menu__link[href^="' + address + '"]').parent().addClass('active').closest('.menu__li-dropdown').addClass('active');;
        $('.menu__li > .menu__link[href^="/' + window.location.pathname.split("/")[1]+ '"]').parent().addClass('active').closest('.menu__li-dropdown').addClass('active');;
    }

    /* Select active menu */
    var adress = window.location.pathname;
    // first = adress.split('/');
    // first = first[1];
    // if (adress == '/') {
    //     $(".menu__ul > .menu__li").eq(0).addClass('active');
    // } else {
    //     $(".menu__ul > .menu__li").each(function (index) {
    //         if ($(this).html().indexOf(adress) > 0) {
    //             $(".menu__ul > .menu__li.active").removeClass('active');
    //             $(this).addClass('active');
    //             if ($(this).hasClass('menu__li-dropdown')) {
    //
    //                 $(this).find('ul li').each(function (index) {
    //                     if ($(this).html().indexOf(adress) > 0) {
    //                         $(this).addClass('active');
    //                     }
    //                 });
    //             }
    //             first = null;
    //             return;
    //         }
    //         else if ($(this).html().indexOf(first) > 0) {
    //             $(this).addClass('active');
    //         }
    //
    //         $('.menu__li.active').closest('.menu__li-dropdown').addClass('active');
    //     });
    // }
    // /* next level menu */
    // $('.dropdown-submenu a.test').on("click", function (e) {
    //     $(this).next('ul').toggle();
    //     e.stopPropagation();
    //     e.preventDefault();
    // });


    $(window).on('scroll', function () {
        var st = $(window).scrollTop();

        if (st > 150) {
            $('.scrollTop').addClass('show');
            if (adress == '/') {
                $('.sidebar__logo').removeClass('hidden');
            }
        } else {
            $('.scrollTop').removeClass('show');
            if (adress == '/') {
                $('.sidebar__logo').addClass('hidden');
            }
        }


    });

    $('.scrollTop').on('click', function (e) {
        e.preventDefault();
        $("html, body").animate({scrollTop: 0}, "slow");
    });


    $('#contactWithSpecialist').on('click', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('show');
    });


    //
    // $(document).on('showLoading', function(){
    //     $('#loadingSpinner').show()
    // });
    //
    // $(document).on('hideLoading', function(){
    //     $('#loadingSpinner').hide()
    // });


    var preloader = $('#preloader');

    $(window).load(function () {
        preloader.addClass('preloader-hiding');

        preloader.bind('transitionend', function () {
            preloader.addClass('preloader-hidden');
            preloader.removeClass('preloader-hiding');
        });

    });

    $('.modal-gallery-button').on('click', function (e) {
        e.preventDefault();
        var modalGallery = $(this).data('gallery');
        $('.' + modalGallery).addClass('active');
        $('html,body').addClass('overflow');
    });

    $('.modalGallery__close').on('click', function (e) {
        e.preventDefault();
        $(this).parent().removeClass('active');
        $('html,body').removeClass('overflow');
    })


//# sourceMappingURL=default.js.map

// script orphan letters

    $('.text ,p ,h1 ,h2 ,h3 ,h4 ,h5 ').each(function () {
        var tekst = $(this).html();
        tekst = tekst.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;"); //jednoznakowe
        tekst = tekst.replace(/(\s)([^<][\S]{1})[\s]+/g, "$1$2&nbsp;"); //dwuznakowe
        $(this).html(tekst);
    });





    function hideDropdownMenu() {
        $('.menu__dropdown').slideUp();
        $('.menu__openList').removeClass('open');
    }



    if ($(document).width() > 1299) {
        $(document).scroll(function () {
            $('.sidebar').animate({
                scrollTop: $(document).scrollTop()
            }, 1);
        })
    }



    $(".menu__li-dropdown > a").on('click', function(e){
        e.preventDefault();
    });


    $('.menuButton').on('click', function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        $('.menu').fadeToggle();
        $('html').toggleClass('overflow');
        $('.socialMediaTop').fadeToggle();
    })

    if (screen.width <= 1024){
        $('.menu__openList').on('click', function(e){
            e.preventDefault();
            $(this).parent().find('ul').slideToggle();
        });
    }




    $('.modal__close').on('click', function (e) {
        e.preventDefault();
        $('.modal').fadeOut();
        $('html').removeClass('overflow');
    });

    function openModal() {
        $('.modal').fadeIn();
        $('html').addClass('overflow');
    }


    function paralaxIt() {
        $('.section--whyUs').parallax({
            imageSrc: '/media/default/bg1.jpg',
            speed: 0.2,
            bleed: 20,
            positionY: '0',
        });

        $('.section__person').parallax({
            imageSrc: '/media/default/p1.png',
            speed: 0.6,
            zIndex: -2,
            positionY: '0',
        });

        $('.section__engine').parallax({
            imageSrc: '/media/default/engine.png',
            speed: 0.8,
            zIndex: -1,
            positionY: '0',

        });

        $('.section--contact').parallax({
            imageSrc: '/media/default/bg3.jpg',
            positionY: '0',
        });
    }


    var resizeTimer = null;
    $(window).resize(function () {
        if (resizeTimer) {
            clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(paralaxIt(), 250);
    });

    paralaxIt();


    $(window).trigger('resize').trigger('scroll');

    $(document).ready(function () {
        $('.components__expandableHeader').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).find('.components__expandableButton').removeClass('active');
                $(this).parent().find('.components__expandableContent').slideUp();
            } else {
                $('.components__expandableHeader').removeClass('active');
                $('.components__expandableButton').removeClass('active');
                $('.components__expandableContent').slideUp();
                $(this).addClass('active');
                $(this).find('.components__expandableButton').addClass('active');
                $(this).parent().find('.components__expandableContent').slideDown();
            }
        });
    });



        $('.iframeOnlyMovie').each(function(){
            var url = $(this).data('url');
            var string = (url.slice(url.lastIndexOf("/")));
            var movie = string.replace("/watch?v=", "https://www.youtube.com/embed/");
            $(this).attr('src', movie);

        });



    $(window).on('scroll', function(){
        var st = $(window).scrollTop();
        if( st > 70 ) {
            $('.top').addClass('sticky');
        } else {
            $('.top').removeClass('sticky');
        }

    });


});
//# sourceMappingURL=default.js.map
